<template>
  <el-dialog
    append-to-body
    width="500px"
    title="创建"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="100px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model.trim="form.data.name"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="营业执照" prop="business_license" class="idPhoto">
        <el-upload
          action=""
          :headers="{ token: token }"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :http-request="httpRequestFront"
          accept="image/jpeg, image/png, image/gif"
        >
          <img
            v-if="form.data.business_license"
            :src="form.data.business_license"
            class="avatar"
            style="object-fit: contain"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { getStorage } from '@/storage'
export default {
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      isChange: false,
      loading: false,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      form: {
        loading: false,
        data: {
          name: "",
          business_license:'',
        },
        rules: {
          name: [{ required: true, message: "请输入姓名", trigger: "change" }],
          business_license: [
            { required: true, message: "请上传", trigger: "change" },
          ],
        },
      },
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 10;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt3M;
    },
    httpRequestFront(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("/common/qiniu/upload", { formData, type: "upload" })
        .then((res) => {
          if (res.code === 1) {
            this.form.data.business_license = res.data.all_path_url;
          }
        });
    },
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _params = {
            name: this.form.data.name,
            business_license: this.form.data.business_license,
          };
          let apiUrl = "/admin/source/addSource";
          this.form.loading = true;
          this.$http
            .post(apiUrl, _params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("创建成功");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  border: 1px dashed #d9d9d9;
}
/* .idPhoto .avatar{
    width: 100% !important;
  } */
.idPhoto .avatar-uploader-icon {
  width: 128px !important;
  height: 128px !important;
  line-height: 128px !important;
  border: 1px dashed #d9d9d9;
}
.onBtn-large {
  display: flex;
  justify-content: center;
}
</style>
